import { useState, useEffect } from 'react';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
const SESSION_KEY = 'vc_utm_params';

export function useUtmParams() {
  const [utmParams, setUtmParams] = useState({});

  useEffect(() => {
    // Try session storage first (persisted from earlier visit)
    const stored = sessionStorage.getItem(SESSION_KEY);
    if (stored) {
      try {
        setUtmParams(JSON.parse(stored));
        return;
      } catch (e) {
        // Ignore parse error
      }
    }

    // Parse from URL
    const params = new URLSearchParams(window.location.search);
    const utm = {};
    let hasUtm = false;
    UTM_KEYS.forEach((key) => {
      const val = params.get(key);
      if (val) {
        utm[key] = val;
        hasUtm = true;
      }
    });

    if (hasUtm) {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(utm));
      setUtmParams(utm);
    }
  }, []);

  return utmParams;
}
